import { Link } from "react-router-dom";
import { mangaList } from "@/mocks/manga";

const featured = mangaList.find((m) => m.isFeatured) ?? mangaList[0];

export default function Hero() {
  return (
    <section className="relative flex h-[560px] w-full items-center justify-center overflow-hidden md:h-[640px]">
      <img
        src="https://readdy.ai/api/search-image?query=stylized%20summer%20swimming%20pool%20scene%20at%20dusk%2C%20warm%20coral%20sunset%20light%20reflecting%20on%20rippling%20water%20surface%2C%20dreamy%20floating%20bubbles%20and%20soft%20petals%2C%20artistic%20editorial%20illustration%20in%20muted%20teal%20and%20coral%20tones%2C%20gentle%20film%20grain%2C%20cinematic%20wide%20composition%2C%20peaceful%20and%20romantic%20mood&width=1600&height=900&seq=hero-manga-01&orientation=landscape"
        alt="《满溢游泳池》漫画 夏日泳池唯美背景"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/60 via-background-950/40 to-background-950/60"></div>

      <div className="relative z-10 w-full max-w-4xl px-4 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm text-background-50 backdrop-blur">
          <i className="ri-fire-line text-accent-100"></i>盛夏口碑恋爱漫画 · 每周六更新
        </span>
        <h2 className="mt-6 font-heading text-3xl leading-tight text-background-50 md:text-5xl">
          《满溢游泳池》
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-background-100 md:text-base">
          夏日、泳池、还有那个并肩划水的少年。藏在心口的心意，正像池水一样一点一点漫过边缘。恋爱与青春的故事，正在这个夏天悄然满溢。
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/article/man-yi-you-yong-chi"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-play-circle-line"></i>立即免费阅读
          </Link>
          <Link
            to="/category/love"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50/15 px-7 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/25 sm:w-auto"
          >
            <i className="ri-book-open-line"></i>浏览全部漫画
          </Link>
        </div>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-6 text-background-100 md:gap-10">
          <div className="text-center">
            <p className="font-heading text-2xl text-background-50">{featured.chapters}+</p>
            <p className="mt-1 text-xs text-background-200">连载章节</p>
          </div>
          <div className="h-10 w-px bg-background-50/30"></div>
          <div className="text-center">
            <p className="font-heading text-2xl text-background-50">{featured.rating.toFixed(1)}</p>
            <p className="mt-1 text-xs text-background-200">读者评分</p>
          </div>
          <div className="h-10 w-px bg-background-50/30"></div>
          <div className="text-center">
            <p className="font-heading text-2xl text-background-50">{featured.views}</p>
            <p className="mt-1 text-xs text-background-200">累计阅读</p>
          </div>
        </div>
      </div>
    </section>
  );
}